import Axios from 'axios';
import { IMaintenanceLogRowEntry } from '../domain/maintenancelogrowentry/IMaintenanceLogRowEntry';
import { IMaintenanceLogRowEntryCreate } from '../domain/maintenancelogrowentry/IMaintenanceLogRowEntryCreate';

export abstract class MaintenanceLogRowEntryApi {
    
    private static axios = Axios.create(
        {
            baseURL: process.env.REACT_APP_URLPATH + "MaintenanceLogRowEntries",
            headers: {
                    'Content-Type': 'application/json'
            }
        }
    );

    static async getAll(jwt: string, maintenanceLogRowId: number): Promise<IMaintenanceLogRowEntry[]> {
        const url = "";
        try {
            const response = await this.axios.get<IMaintenanceLogRowEntry[]>(url, {params: {maintenanceLogRowId: maintenanceLogRowId}, headers: { Authorization: "Bearer " + jwt }});
            if (response.status === 200) {
                return response.data;
            }
            return [];
        } catch (error) {
            // console.log("error: ", (error as Error).message);
            return [];
        }
    }

    static async createNew(jwt: string, maintenanceLogRowEntry: IMaintenanceLogRowEntryCreate): Promise<IMaintenanceLogRowEntry | null> {
        const url = "";
        try {
            const response = await this.axios.post(url, maintenanceLogRowEntry, { headers: { Authorization: "Bearer " + jwt } });
            // console.log('Create response', response);
            if (response.status === 201) {
                return response.data;
            }
            return null;
        } catch (error) {
            // console.log('error: ', (error as Error).message);
            return null;
        }
    }
    
    /*
    static async getDetails(jwt: string, id: string): Promise<IMaintenanceLog | null> {
        const url = "" + id;
        try {
            const response = await this.axios.get<IMaintenanceLog>(url, { headers: { Authorization: "Bearer " + jwt } });
            //console.log('getDetails response', response);
            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.log('error: ', (error as Error).message);
            return null;
        }
    }
    */
}